import { ReactNode, useEffect, useState } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { Loader2 } from "lucide-react"

import { setupApi, type SetupStatus } from "@/services/setup"

interface SetupGateProps {
  children: ReactNode
}

function SetupGateLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  )
}

export function SetupGate({ children }: SetupGateProps) {
  const location = useLocation()
  const [status, setStatus] = useState<SetupStatus | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    setupApi
      .status()
      .then((nextStatus) => {
        if (!cancelled) setStatus(nextStatus)
      })
      .catch(() => {
        if (!cancelled) setStatus(null)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  if (isLoading) return <SetupGateLoading />

  if (status?.requiresSetup && location.pathname !== "/setup") {
    return <Navigate to="/setup" replace />
  }

  return <>{children}</>
}

